import React from "react";
import { useActor } from "@xstate/react";
import SingleSelect from "../SingleSelect";
import { COUNTRIES } from "../../../../constants/countries";
import { useSignUpMachine } from "../../context/SignUpMachineContext";
import { SignUpFormField } from "../../constants/signup-form-field.enum";
import { CountryValue } from "../../constants/signup-value.enum";
import { BalancedStepTitle } from "../BalancedStepTitle";

const CountryStep: React.FC = () => {
  const machine = useSignUpMachine();
  const [state, send] = useActor(machine);
  const { formData } = state.context;

  const countryValue = formData[SignUpFormField.Country];
  const typeaheadPlaceholder = "Search for your country";

  const handleChange = (value: any) => {
    send({
      type: "UPDATE_FORM",
      data: { [SignUpFormField.Country]: value },
    });
  };

  const field = {
    id: SignUpFormField.Country,
    required: true,
    options: [
      {
        id: "input-country-usa",
        label: "USA",
        value: CountryValue.UnitedStates,
        icon: "🇺🇸",
      },
      {
        id: "input-country-canada",
        label: "Canada",
        value: CountryValue.Canada,
        icon: "🇨🇦",
      },
      {
        id: "input-country-australia",
        label: "Australia",
        value: CountryValue.Australia,
        icon: "🇦🇺",
      },
      {
        id: "input-country-uk",
        label: "United Kingdom",
        value: CountryValue.UnitedKingdom,
        icon: "🇬🇧",
      },
      {
        id: "input-country-other",
        label: "Find Your Country",
        value: CountryValue.Other,
        enableSearchDropdown: true,
        icon: "🌎",
      },
    ],
    extraOptions: COUNTRIES.map((country) => ({
      id: `input-country-generated-${country.name}`,
      label: country.name,
      value: country.name,
    })),
  };

  return (
    <>
      <div className="tw-flex tw-flex-col tw-items-center tw-space-y-1 tw-text-center">
        <BalancedStepTitle title="Where is your gym located?" />
      </div>

      <div className="tw-space-y-4">
        <SingleSelect
          options={field.options}
          extraOptions={field.extraOptions}
          onChange={handleChange}
          value={countryValue}
          typeaheadPlaceholder={typeaheadPlaceholder}
          progressOnSelect={() => send({ type: "NEXT" })}
        />
      </div>
    </>
  );
};

export default CountryStep;
